import { useState, useRef, useEffect } from 'react';
import styles from './listView.module.scss';

export const ActionDropdown = ({ action, triggerClassName, requestReload, selectedCategory }) => {
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);
    const items = action.menuItems?.(requestReload, selectedCategory) ?? [];

    useEffect(() => {
        if (!open) return;
        const onOutside = (e) => {
            if (!rootRef.current?.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', onOutside);
        return () => document.removeEventListener('mousedown', onOutside);
    }, [open]);

    return (
        <div ref={rootRef} className={styles.actionDropdown}>
            <div className={triggerClassName} onClick={() => items.length && setOpen((v) => !v)}>
                {action.buttonLabel}
                <div className="actionIcon">{action.icon}</div>
            </div>
            {open && items.length > 0 ? (
                <div className={styles.actionDropdownMenu}>
                    {items.map(({ label, onClick, closeOnClick = true }, i) => (
                        <div
                            key={typeof label === 'string' ? label : i}
                            className={styles.actionDropdownItem}
                            onClick={(e) => {
                                if (closeOnClick) setOpen(false);
                                onClick?.(e, requestReload, selectedCategory, { closeMenu: () => setOpen(false) });
                            }}
                        >
                            {label}
                        </div>
                    ))}
                </div>
            ) : null}
        </div>
    );
};
